import {
  merkleTreeToJson,
  findNodeByJsonPath,
} from './json_merkle.js';

export default {
  getJson: function(jsonPath = '') {
    const ctx = this;
    if (Array.isArray(jsonPath)) {
      return jsonPath.map(item => ctx.getJson(item));
    }

    const {
      node
    } = findNodeByJsonPath(this.immutableTree.root, jsonPath);
    return merkleTreeToJson(node);
  },

  getType: function(jsonPath) {
    const {
      node
    } = findNodeByJsonPath(this.immutableTree.root, jsonPath);
    return node.data.type;
  },

  getLength: function(jsonPath) {
    const {
      node
    } = findNodeByJsonPath(this.immutableTree.root, jsonPath);
    return node.children.length;
  },

  getObjectSize: function(jsonPath) {
    return this.getLength(jsonPath) / 2;
  },

  getObjectKeys: function(jsonPath) {
    const {
      node
    } = findNodeByJsonPath(this.immutableTree.root, jsonPath);
    if (node.data.type !== 'object') {
      throw new Error('node type is not object');
    }

    const keys = [];
    for (let i = 0; i < node.children.length; i += 2) {
      keys.push(merkleTreeToJson(node.children[i]));
    }

    return keys;
  },

  // loop json array
  // handler: (childNode, index) -> void
  map: function(jsonPath, handler) {
    const {
      node
    } = findNodeByJsonPath(this.immutableTree.root, jsonPath);
    if (node.data.type !== 'array') {
      throw new Error(`node type is not array, but ${node.data.type}`);
    }

    const self = this;

    return node.children.map((child, index) => {
      return handler(self._subByNode(child), index);
    });
  },

  getHash: function(jsonPath = '') {
    const {
      node
    } = findNodeByJsonPath(this.immutableTree.root, jsonPath);
    return node.getHash();
  },
};
